export enum IconSize {
  XXS = 'xxs',
  XS = 'xs',
  S = 's',
  M = 'm',
  L = 'l',
  XL = 'xl',
}

export enum IconName {
  AdultsOnly = '18-plus',
  Alert = 'alert',
  AlertTriangle = 'alert-triangle',
  ArrowLines = 'arrow-lines',
  Bolt = 'bolt',
  BoltFilled = 'bolt-filled',
  Briefcase = 'briefcase',
  BriefcaseOff = 'briefcase-off',
  BriefcaseWithAdd = 'briefcase-with-add',
  Badge = 'badge',
  Bus = 'bus',
  BusOff = 'bus-off',
  Calendar = 'calendar',
  Star = 'star',
  Car = 'car',
  Chat = 'chat',
  Check = 'check',
  ChevronDown = 'chevron-down',
  ChevronLeft = 'chevron-left',
  ChevronRight = 'chevron-right',
  ChevronUp = 'chevron-up',
  Child = 'child',
  Clock = 'clock',
  Close = 'close',
  Conditioning = 'conditioning',
  CreditCard = 'credit-card',
  CriticalError = 'critical-error',
  Crown = 'crown',
  Cube = 'cube',
  Copy = 'copy',
  Dash = 'dash',
  DoubleChevronLeft = 'double-chevron-left',
  DoubleChevronRight = 'double-chevron-right',
  Download = 'download',
  Edit = 'edit',
  ExternalLink = 'external-link',
  Hotel = 'hotel',
  HotelService = 'hotel-service',
  Info = 'info',
  InfoCircle = 'info-circle',
  Fire = 'fire',
  FireFilled = 'fire-filled',
  FirstAidKit = 'first-aid-kit',
  Kitchen = 'kitchen',
  Luggage = 'luggage',
  LuggageOff = 'luggage-off',
  LuggageWithAdd = 'luggage-with-add',
  Moon = 'moon',
  More = 'more',
  Phone = 'phone',
  PlaneFilled = 'plane-filled',
  Plane = 'plane',
  Plus = 'plus',
  Refresh = 'refresh',
  Success = 'success',
  Search = 'search',
  Question = 'question',
  QuestionMark = 'question-mark',
  User = 'user',
  Walk = 'walk',
  Wallet = 'wallet',
  Wifi = 'wifi',
  Camera = 'camera',
  Lamp = 'lamp',
  Hours24 = '24-hours',
  Pin = 'pin',
  Ski = 'ski',
  Ruble = 'ruble',
  Russian = 'russian',
  Spa = 'spa',
  StarEmpty = 'star-empty',
  Tent = 'tent',
  Trash = 'trash',
  Flag = 'flag',
  MessageChatbot = 'message-chatbot',
  MessageDots = 'message-dots',
  Menu = 'menu',
  Key = 'key',
  Ban = 'ban',
  CircleCheck = 'circle-check',
  Clock72 = 'clock-72',
  ClockFilled = 'clock-filled',
  Discount = 'discount',
  PlayerTrackNext = 'player-track-next',
  RotateClockwise = 'rotate-clockwise',
  ShieldCheck = 'shield-check',
  ClockExclamation = 'clock-exclamation',
  Wrong = 'wrong',
  Mail = 'mail',
  Heart = 'heart',
  Headset = 'headset',
  Beach = 'beach',
  Filters = 'filters',
  Logout = 'logout',
  PointFilled = 'point-filled',
  Train = 'train',
  MinimizeOn = 'minimize-on',
  MinimizeOff = 'minimize-off',
  History = 'history',
  ArrowUpRight = 'arrow-up-right',
  DeviceDesktop = 'device-desktop',
}
